module.exports = __webpack_public_path__ + "img/SOUND.4c47a05d.svg";